import { render, staticRenderFns } from "./InformationMore.vue?vue&type=template&id=16364bb6&scoped=true"
import script from "./InformationMore.vue?vue&type=script&lang=js"
export * from "./InformationMore.vue?vue&type=script&lang=js"
import style0 from "./InformationMore.vue?vue&type=style&index=0&id=16364bb6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16364bb6",
  null
  
)

export default component.exports